export const topUpWithdrawMockData = [
  {
    id: "261",
    date: "2026-03-10",
    displayDate: "10/03/2026",
    time: "10:43:53",
    type: "Withdraw",
    customerName: "Quang Nguyen",
    customerEmail: "checkpast12month@yopmail.com",
    amount: "100 SGD",
    fee: "6.55 SGD",
  },
  {
    id: "260",
    date: "2026-03-10",
    displayDate: "10/03/2026",
    time: "10:29:55",
    type: "Top-up",
    customerName: "SparkMinds Technology Pte Ltd",
    customerEmail: "checkpast12month@yopmail.com",
    amount: "2 SGD",
    fee: "--",
  },
  {
    id: "259",
    date: "2026-03-10",
    displayDate: "10/03/2026",
    time: "10:27:44",
    type: "Top-up",
    customerName: "SparkMinds Technology Pte Ltd",
    customerEmail: "checkpast12month@yopmail.com",
    amount: "400 SGD",
    fee: "--",
  },
  {
    id: "258",
    date: "2026-03-10",
    displayDate: "10/03/2026",
    time: "10:27:16",
    type: "Top-up",
    customerName: "SparkMinds Technology Pte Ltd",
    customerEmail: "checkpast12month@yopmail.com",
    amount: "1,000 SGD",
    fee: "--",
  },
  {
    id: "257",
    date: "2026-03-09",
    displayDate: "09/03/2026",
    time: "11:50:19",
    type: "Top-up",
    customerName: "SparkMinds Technology Pte Ltd",
    customerEmail: "checkpast12month@yopmail.com",
    amount: "110,117 SGD",
    fee: "--",
  },
];
